module.exports = __webpack_public_path__ + "media/10x20.eb5dedee.png";